/* Soft Hours CMS — fills the page from Supabase site_content on load.
   Tag elements with:
     data-cms="key"      -> textContent
     data-cms-bg="key"   -> style.backgroundImage
     data-cms-src="key"  -> src (img)
   Content is public-read; only the /admin editor (logged in) can write. */
(() => {
  const CONFIG = window.SOFT_HOURS_REVIEW_CONFIG || {};
  const URL = (CONFIG.supabaseUrl || "").replace(/\/$/, "");
  const KEY = CONFIG.supabaseAnonKey || "";
  if (!URL || !KEY) return;

  const pageName = () => {
    if (window.SOFT_HOURS_CMS_PAGE) return window.SOFT_HOURS_CMS_PAGE;
    const p = window.location.pathname.replace(/\/$/, "");
    if (!p || p === "/index.html") return "home";
    return p.split("/").pop().replace(/\.html$/, "") || "home";
  };

  const apply = (map) => {
    document.querySelectorAll("[data-cms]").forEach((el) => {
      const v = map[el.getAttribute("data-cms")];
      if (v != null) el.textContent = v;
    });
    document.querySelectorAll("[data-cms-bg]").forEach((el) => {
      const v = map[el.getAttribute("data-cms-bg")];
      if (v) el.style.backgroundImage = `url('${v}')`;
    });
    document.querySelectorAll("[data-cms-src]").forEach((el) => {
      const v = map[el.getAttribute("data-cms-src")];
      if (v) el.setAttribute("src", v);
    });
  };

  // When opened from the editor's "View page" button (?preview=…), show a way back.
  const addBackToEditor = () => {
    if (!new URLSearchParams(window.location.search).has("preview")) return;
    if (document.querySelector(".cms-back")) return;
    const bar = document.createElement("a");
    bar.className = "cms-back";
    bar.href = "admin.html";
    bar.textContent = "← Back to editor";
    bar.style.cssText = "position:fixed;bottom:18px;left:18px;z-index:2147483647;background:#26241A;color:#F2EBDD;font-family:'Courier New',Courier,monospace;font-size:13px;letter-spacing:0.08em;text-decoration:none;padding:11px 18px;box-shadow:0 6px 20px rgba(0,0,0,0.28);";
    bar.addEventListener("click", (e) => {
      // If this tab was opened from the editor, just return to it and close the preview.
      if (window.opener && !window.opener.closed) {
        e.preventDefault();
        try { window.opener.focus(); window.close(); } catch (_) { window.location.href = "admin.html"; }
      }
    });
    document.body.appendChild(bar);
  };

  const load = async () => {
    try {
      const res = await fetch(`${URL}/rest/v1/site_content?page=eq.${encodeURIComponent(pageName())}&select=key,value`, {
        headers: { apikey: KEY, Authorization: `Bearer ${KEY}` },
      });
      if (!res.ok) return;
      const rows = await res.json();
      const map = {};
      rows.forEach((r) => { if (r.value != null && r.value !== "") map[r.key] = r.value; });
      apply(map);
    } catch (e) { /* keep the built-in defaults on any failure */ }
  };

  load();
  addBackToEditor();
})();
